/* global jQuery, js_vars, elementorFrontend, Mmenu */
const theme_url = ('themeurl' in js_vars) ? js_vars.themeurl : 'https://www.trinity.com/wp-content/themes/trinity';

/*--------------------------------------------------------------------------------
General Ready
--------------------------------------------------------------------------------*/
( function( $ ) {
$(document).ready(function(){
	
	const siteWidth = 1320,
	mobileWidth = 768;

	/*--------------------------------------------------------------------------------
	Utility: Hide element on click outside
	--------------------------------------------------------------------------------*/
	
	function hideOnClickOutside( selector, type = 'standard' ) {
		const outsideClickListener = (event) => {
			const $target = $(event.target);
			if ( ! $target.closest(selector).length ) {
				$(selector).removeClass('open');
				if ( type == 'menu' ) {
					$('.header__menu-button').removeClass('is-active');
				}
				removeClickListener();
			}
		}

		const removeClickListener = () => {
			document.removeEventListener('click', outsideClickListener)
		}
		
		document.addEventListener('click', outsideClickListener)
	}


	/*--------------------------------------------------------------------------------
	Utility: Scroll to internal links
	--------------------------------------------------------------------------------*/

	// $('a[href*="#"]')
	// 	.not('[href="#"]')
	// 	.not('[href="#0"]')
	// 	.click(function( event ) {
	// 		if( location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname ) {
	// 			let target = $(this.hash);
	// 			target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
	// 			if( target.length ) {
	// 				event.preventDefault();
	// 				$( 'html, body' ).animate({
	// 					scrollTop: target.offset().top - 36
	// 				}, 1000, function() {
	// 					let $target = $(target);
	// 					$target.focus();
						
	// 					if( $target.is(":focus") ) {
	// 						return false;
	// 					} else {
	// 						$target.attr('tabindex','-1');
	// 						$target.focus();
	// 					}
	// 				});
	// 			}
	// 		}
	// 	});


	/*--------------------------------------------------------------------------------
	Utility: Copy URL
	--------------------------------------------------------------------------------*/

	$( document ).on( 'click', '.copy-url', function(e){
		e.preventDefault();

		let $this = $(this);
		let url = $this.attr('href');

		navigator.clipboard.writeText(url).then(function() {
			$this.text('Copied!');
		});
	});		


	/*--------------------------------------------------------------------------------
	Mobile Menu - General
	--------------------------------------------------------------------------------*/

	// $(document).on( 'click', '#site-header__mobile-button', function(e){
	// 	let $this = $(this);
	// 	$this.toggleClass('is-active');
	// });

	// if( ! $('body').hasClass('elementor-editor-active') ) {
	// 	window.stickyHeader = $('#site-header').stickybits({
	// 		useStickyClasses: true
	// 	});

	// 	if( $(window).width() > mobileWidth ) {
	// 		$('.site-main').css("margin-top", - $('#site-header').height());
	// 	}
	// }


	/*--------------------------------------------------------------------------------
	Header - Search
	--------------------------------------------------------------------------------*/

	$('.header__search .icon').click(function(e){
		e.preventDefault();

		// Handle outside clicks
		var $parent = $(this).parent();
		$parent.toggleClass('open');
		hideOnClickOutside($parent);

		if( $parent .hasClass('open') ) {
			$parent.find('[name="s"]').focus();
		}
	});


	/*--------------------------------------------------------------------------------
	Forms: Dropdown
	--------------------------------------------------------------------------------*/

	$('.form-dropdown .dropdown-title').click(function(e){
		e.preventDefault();

		// Handle outside clicks
		var $parent = $(this).parent('.form-dropdown');
		$parent.toggleClass('open');
		hideOnClickOutside($parent);
	});

	$(document).on( 'change', '.dropdown-content', function(e) {
		$('.form-dropdown').removeClass('open');

		var target = $(e.target);
		var dropdown_label = target.data('label');
		target.parents('.form-dropdown').find('.dropdown-title').text(dropdown_label);
	});

	// $(document).on( 'change', '.blog-search-form .dropdown-content', function(e) {
	// 	var target = $(e.target);
	// 	window.location.href = target.data('url');
	// });

} );
} )( jQuery );


/*--------------------------------------------------------------------------------
Mobile Menu - Mmenu.js
--------------------------------------------------------------------------------*/
// document.addEventListener(
// 	"DOMContentLoaded", () => {
// 		new Mmenu( "#mobile-menu", {
// 			"theme": "light",
// 			"navbar": {
// 				"add": false
// 			},
// 			// "navbars": [
// 			// 	{
// 			// 		"position": "top",
// 			// 		"content": [
// 			// 			"<div class='mobile-menu__logo-container'><img class='mobile-menu__logo' src='" + theme_url + "/assets/images/logo.png' alt='Trinity' /></div>",
// 			// 			"prev",
// 			// 			"title",
// 			// 			"close"
// 			// 		]
// 			// 	},
// 			// 	// {
// 			// 	// 	"position": "bottom",
// 			// 	// 	"content": [
// 			// 	// 		"<a class='button' href='" + getstarted_url + "'>Get Started</a>"
// 			// 	// 	]
// 			// 	// }
// 			// ],
// 			// hooks: {
// 			// 	"openPanel:before": ( panel ) => {
// 			// 		let nav_top = document.getElementById("mobile-menu");
// 			// 		if( panel.id == 'mm-1' ) {
// 			// 			nav_top.classList.add("mm-home");
// 			// 		} else {
// 			// 			nav_top.classList.remove("mm-home");
// 			// 		}
// 			// 	}
// 			// }
// 		}, {
// 			"offCanvas": {
// 				// "clone": "true",
// 				"page": {
// 					selector: "#site-container"
// 				},
// 				"position": "left"
// 			},
// 		});
// 	}
// );